import { useEffect, useState } from "react";
import { Loader2, Receipt } from "lucide-react";
import { api } from "@/lib/api";

const STATUS_STYLE = {
  paid: "bg-emerald-500/15 text-emerald-400", pending: "bg-amber-500/15 text-amber-400", refunded: "bg-sky-500/15 text-sky-400", failed: "bg-rose-500/15 text-rose-400",
  cancelled: "bg-secondary text-muted-foreground", created: "bg-amber-500/15 text-amber-400",
};
const LABEL = { created: "pending" };

export const money = (amount, currency) => new Intl.NumberFormat(undefined, { style: "currency", currency }).format(amount);

export const StatusBadge = ({ status }) => (
  <span className={`text-[11px] uppercase tracking-wider font-bold rounded-full px-2.5 py-1 ${STATUS_STYLE[status] || ""}`}>{LABEL[status] || status}</span>
);

export const PaymentHistory = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/payments/history").then((r) => setRows(r.data.payments)).catch(() => setRows([])); }, []);
  return (
    <section className="panel p-6 space-y-4" data-testid="payment-history">
      <h2 className="text-lg font-semibold flex items-center gap-2"><Receipt className="h-5 w-5" />Payment history</h2>
      {!rows && <Loader2 className="h-5 w-5 animate-spin text-primary" />}
      {rows?.length === 0 && <p className="text-sm text-muted-foreground" data-testid="payment-history-empty">No payments yet.</p>}
      {rows?.length > 0 && (
        <ul className="divide-y divide-border">
          {rows.map((p) => (
            <li key={p.order_id} data-testid={`payment-row-${p.order_id}`} className="py-3 flex flex-wrap items-center gap-3 text-sm">
              <span className="font-semibold">{money(p.amount, p.currency)}</span>
              {p.plan_name && <span className="text-xs text-muted-foreground" data-testid="payment-plan-name">{p.plan_name}{p.credits ? ` · ${p.credits} gen` : ""}</span>}
              <span className="text-muted-foreground capitalize">{p.provider}</span>
              <StatusBadge status={p.status} />
              {p.test_mode && <span className="text-[11px] text-amber-400">test</span>}
              {p.transaction_id && <span className="text-[11px] text-muted-foreground font-mono">{p.transaction_id}</span>}
              <span className="ml-auto text-xs text-muted-foreground">{new Date(p.created_at).toLocaleString()}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
